function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8.66634H8.66671V11.9997C8.66671 12.3663 8.36671 12.6663 8.00004 12.6663C7.63337 12.6663 7.33337 12.3663 7.33337 11.9997V8.66634H4.00004C3.63337 8.66634 3.33337 8.36634 3.33337 7.99967C3.33337 7.63301 3.63337 7.33301 4.00004 7.33301H7.33337V3.99967C7.33337 3.63301 7.63337 3.33301 8.00004 3.33301C8.36671 3.33301 8.66671 3.63301 8.66671 3.99967V7.33301H12C12.3667 7.33301 12.6667 7.63301 12.6667 7.99967C12.6667 8.36634 12.3667 8.66634 12 8.66634Z",
  fill: "white"
});
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0fdf1b81d5b3454f1d5e9d34c780d879.svg";
export { ForwardRef as ReactComponent };